var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item-detail-component',{attrs:{"item-type":'entryDetail',"item-key":_vm.entryKey}}),_c('judge-write-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }